import { ObjectHelperBaseObject } from '@models/object-helper-base';
import { ClassCast } from '@shared/zb-object-helper/class-cast';
import moment, { Moment, isMoment } from 'moment';
import LicenseActivity from './license-activity.model';
import { PlannerCardThumbnailModel } from './planner-card-thumbnail.model';
import { PlannerGroupThumbnailModel } from './planner-group-thumbnail.model';
import { PlannerWeekDay } from './planner-week-day.model';

export class PlannerModel extends ObjectHelperBaseObject {
  planId: string = undefined;
  private _beginningDate: Moment = undefined;
  weekId: string = undefined;
  themeId: string = undefined;
  groupIconPath: string = undefined;
  @ClassCast(PlannerGroupThumbnailModel)
    plannerGroupThumbnails: PlannerGroupThumbnailModel[] = [];
  @ClassCast(PlannerCardThumbnailModel)
    plannerCardThumbnails: PlannerCardThumbnailModel[] = [];

  _fridayCardThumbnails: PlannerCardThumbnailModel[] = [];
  daysOfWeek: PlannerWeekDay[] = [];
  hasPrintResources: boolean = undefined;

  tutorialVideoLicenseActivities: LicenseActivity[] = [];

  public set beginningDate(beginningDate: string | Moment) {
    if (beginningDate && !isMoment(beginningDate)) {
      this._beginningDate = moment(beginningDate);
    }
    this.daysOfWeek = PlannerWeekDay.generateWeek(this._beginningDate);
  }

  public get beginningDate(): Moment {
    return this._beginningDate;
  }

  public get beginningDateAsIsoString(): string {
    return this._beginningDate.toISOString();
  }

  get fridayCardThumbnails(): PlannerCardThumbnailModel[] {
    return this._fridayCardThumbnails;
  }

  onInit(): void {
    this.organizePlannerCardThumbnails();
  }

  organizePlannerCardThumbnails(): void {
    /* eslint-disable no-param-reassign*/
    this.plannerGroupThumbnails.forEach((group) => {

      //eslint-disable-next-line
      group.plannerCardThumbnails = this.plannerCardThumbnails.filter((card) => {
        return card.plannerGroupId === group.plannerGroupId && card.dayOfWeek !== 5;
      }).sort((a, b) => (a.dayOfWeek < b.dayOfWeek ? -1 : 1));

      group.plannerCardThumbnails.forEach((card, i) => {
        let thumbnailWidth = 1;
        let j = i + 1;
        card.thumbnailStartingDayPlannerCardId = card.plannerCardId;

        while (j < group.plannerCardThumbnails.length && group.plannerCardThumbnails[j].cardId === card.cardId
          && group.plannerCardThumbnails[j].dayOfWeek === card.dayOfWeek + thumbnailWidth) {
          thumbnailWidth++;
          j++;
        }

        card.thumbnailWidth = thumbnailWidth;

        // check to ensure thumbnail width won't exceed the 4 days allowed
        if ((card.dayOfWeek + card.thumbnailWidth - 1) > 4) {
          card.thumbnailWidth = 5 - card.dayOfWeek;
        }

        if (i > 0) {
          const previousCard = group.plannerCardThumbnails[i - 1];
          if (this.cardIsPartOfPreviousCardThumbnail(card, previousCard)) {
            card.isPartOfPreviousDayCard = true;
            card.isMultiDayCard = true;
            previousCard.isMultiDayCard = true;
            card.thumbnailStartingDayPlannerCardId  = previousCard.thumbnailStartingDayPlannerCardId;
          } else {
            card.isPartOfPreviousDayCard = false;
          }
        } else {
          card.isPartOfPreviousDayCard = false;
        }
      });

      const weekDays: (PlannerCardThumbnailModel | null)[] = [null, null, null, null];
      group.plannerCardThumbnails.forEach((card) => {
        weekDays[card.dayOfWeek - 1] = card;
      });
      group.weekDays = weekDays;
    });
    /* eslint-enable no-param-reassign*/

    this._fridayCardThumbnails = this.plannerCardThumbnails.filter(card => card.dayOfWeek === 5)
      .sort((a, b) => (a.weight < b.weight ? -1 : 1));
  }

  private cardIsPartOfPreviousCardThumbnail(card: PlannerCardThumbnailModel, previousCard: PlannerCardThumbnailModel):boolean {
    return previousCard?.cardId === card.cardId && previousCard.dayOfWeek === card.dayOfWeek - 1;
  }
}
